export enum CommunicationLanguage {
    EN = 'EN',
    FR = 'FR'
}
